<template>
  <LoadingData v-if="isLoadingData" />
  <div v-else class="card">
    <div class="d-flex flex-column align-items-center text-center h-100 mt-4">
      <img src="@/assets/img/logo_nextgen.png" class="h-80px" />
      <h1>Obrigado por sua participação</h1>
      <div class="alert alert-primary mb-0">
        Você acertou {{ form.correctQuestion }} de
        {{ form.totalQuestion }} perguntas
      </div>
    </div>
    <hr />
    <h4 class="text-center mb-0">{{ form.title }}</h4>
    <div class="list-group list-group-flush">
      <div
        v-for="(question, index) in form.questions"
        :key="question.id"
        class="list-group-item py-3"
      >
        <p class="fw-bold">{{ index + 1 }}) {{ question.text }}</p>
        <img
          v-if="question.image"
          :src="question.image"
          class="img-fluid mb-3"
        />
        <label
          v-for="option in question.options"
          :key="option.id"
          class="form-check cp mb-2"
        >
          <input
            type="radio"
            class="form-check-input"
            :id="`question${question.id}${index}`"
            :value="option.id"
            :checked="option.optionSelected"
            disabled
          />
          <span
            class="form-check-label"
            :class="{
              'fw-bolder text-success': option.correct === '1',
              'fw-bolder text-danger':
                option.correct === '0' && option.optionSelected,
            }"
          >
            {{ option.text }}
            <img
              v-if="option.image"
              :src="option.image"
              class="img-fluid mb-3"
            />
          </span>
        </label>
      </div>
      <div class="list-group-item text-center py-3">
        <button
          type="button"
          class="btn btn-primary w-size"
          title="Finalizar"
          @click="finish"
        >
          Finalizar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Results',

  components: {
    LoadingData,
  },

  data() {
    return {
      isLoadingData: true,
      code: this.$route.params.code,
      form: null,
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    async getAnswers() {
      try {
        this.form = await this.$store.dispatch('getAnswers', {
          code: this.code,
          filters: {
            userId: this.user.id,
          },
        })

        this.isLoadingData = false
      } catch (error) {
        this.isLoadingData = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }

        this.finish()
      }
    },

    finish() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'Form' })
      })
    },
  },

  mounted() {
    this.getAnswers()
  },
}
</script>

<style scoped>
.w-size {
  width: 100% !important;
}

@media (min-width: 768px) {
  .w-size {
    width: 50% !important;
  }
}

@media (min-width: 992px) {
  .w-size {
    width: 35% !important;
  }
}

@media (min-width: 1200px) {
  .w-size {
    width: 20% !important;
  }
}
</style>
